type SectionLabelProps = {
    title: string;
    description: string;
};

function SectionLabel({ title, description }: SectionLabelProps): JSX.Element {
    return (
        <section className="flex flex-col items-start">
            <label className="text-sm font-medium text-gray-800 dark:text-gray-200">{title}</label>
            <p className="text-xs font-normal text-gray-600 dark:text-gray-400">{description}</p>
        </section>
    );
}

export default SectionLabel;
